import type { MessageKey } from "@erp/i18n";
import { ApiError } from "./api";

/** Maps any thrown value to the i18n key that best explains it to the user. */
export function errorMessageKey(error: unknown): MessageKey {
  if (!(error instanceof ApiError)) return "errors.generic";
  if (error.isNetwork) return navigator.onLine ? "errors.network" : "errors.offline";
  const body = error.body;
  if (body?.kind === "domain" && body.code) return `errors.codes.${body.code}` as MessageKey;
  switch (body?.kind ?? error.status) {
    case "unauthorized":
    case 401:
      return "errors.unauthorized";
    case "forbidden":
    case 403:
      return "errors.forbidden";
    case "notFound":
    case 404:
      return "errors.notFound";
    case "validation":
    case 422:
      return "errors.validation";
    case "conflict":
    case 409:
      return "errors.conflict";
    case "rateLimited":
    case 429:
      return "errors.rateLimited";
    default:
      return "errors.generic";
  }
}

export function fieldErrors(error: unknown): Record<string, string> {
  return error instanceof ApiError && error.body?.kind === "validation" ? (error.body.fields ?? {}) : {};
}

/** Values a domain error names (the product that blocks an operation…), empty when there are none. */
export function errorDetails(error: unknown): Record<string, string> {
  return error instanceof ApiError && error.body?.kind === "domain" ? (error.body.details ?? {}) : {};
}
